import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'itpx-transacion-aprovals',
    templateUrl: './transacion-aprovals.component.html',
    styleUrls: ['transacion-aprovals.component.css']
})
export class TransactionApprovalsComponent {

    refreshAll$: Subject<never> = new Subject();

    constructor() { }

    refreshAll() {
        this.refreshAll$.next();
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/transacion-aprovals/transacion-aprovals.component.ts